import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import IconButton from 'apollo-react/components/IconButton';
import Popover from 'apollo-react/components/Popover';
import Typography from 'apollo-react/components/Typography';
import Translate from 'apollo-react-icons/Translate';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomLoader from './CustomLoader';
import { handleErrors } from '../actions/ErrorActions';
import { addAIGeneratedContentToast } from '../actions/ToastActions';
import { fetchOnDemandTranslation } from '../api/translations';
import { getAppSettings } from '../selectors/AppConfigsSelectors';
import { getLanguage } from '../selectors/AuthSelectors';
import { checkTrue, getHtmlFreeValue } from '../utils/commonUtils';

const useStyles = makeStyles({
  readOnlyControl: {
    marginLeft: 5,
    position: 'relative',
    top: -12,
  },
  connectedControl: {
    marginTop: 16,
  },
  translatedTextContainer: {
    padding: 20,
    maxWidth: 500,
    maxHeight: 300,
    overflowY: 'auto',
  },
  translatedText: {
    whiteSpace: 'pre-wrap',
  },
});

const RuntimeTranslation = ({ value, isReadOnly }) => {
  const dispatch = useDispatch();
  const language = useSelector(getLanguage);
  const { 'AzureCognitiveTranslationService/Enabled': translationServiceEnabledFlag } = useSelector(
    getAppSettings
  );
  const htmlFreeValue = getHtmlFreeValue(value);
  const iconSize = isReadOnly ? 'small' : 'medium';
  const classes = useStyles();

  const [translatedValue, setTranslatedValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const onTranslateClickHandler = async ({ currentTarget }) => {
    setIsLoading(true);
    setAnchorEl((prev) => (!prev ? currentTarget : null));
    const data = await fetchOnDemandTranslation(htmlFreeValue, language);

    if (data.hasError) {
      dispatch(handleErrors(data.errors));
      setIsLoading(false);
      setTranslatedValue('');
      setAnchorEl(null);
      return;
    }
    dispatch(addAIGeneratedContentToast());
    setIsLoading(false);
    const newValue = _.get(data, 'OnDemandTranslation[0].Translations[0].Text', '');
    setTranslatedValue(newValue);
  };

  return (
    checkTrue(translationServiceEnabledFlag) && (
      <>
        <IconButton
          onClick={onTranslateClickHandler}
          disabled={!htmlFreeValue}
          size={iconSize}
          className={!isReadOnly ? classes.connectedControl : classes.readOnlyControl}
          aria-label="translate"
        >
          <Translate />
        </IconButton>
        <Popover
          open={!!anchorEl}
          anchorEl={anchorEl}
          PaperProps={{
            style: {
              boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.08)',
            },
          }}
          onBackdropClick={() => setAnchorEl(null)}
        >
          <Card interactive className={classes.translatedTextContainer}>
            {isLoading ? (
              <CustomLoader />
            ) : (
              <Typography className={classes.translatedText}>{translatedValue}</Typography>
            )}
          </Card>
        </Popover>
      </>
    )
  );
};

export default RuntimeTranslation;
